// extracted by mini-css-extract-plugin
export default {"container":"Container_container__njmkI","isFull":"Container_isFull__EVAc0","isSlim":"Container_isSlim__MrFVN"};